import I18N from 'assets/i18n/brandlift';

import {Metric, BrandliftStrategy} from 'client/common/types/brandlift/types';
import {ImageDimensions} from 'client/common/utils/image-uploader';

const i18n = I18N.createForm;

export const BrandTypes = {
    PRODUCT: i18n.brandTypes.product,
    SERVICE: i18n.brandTypes.service
};

export interface BrandliftLogo {
    url?: string;
    name: string;
    dimensions?: ImageDimensions
    error?: string;
};

export interface BrandliftContext {
    brand?: string;
    brandType?: string;
    industry?: string;
    brands?: string[];
    adMessage?: string;
    adMessages?: string[];
    customMetrics?: Metric[];
    metricLabels: {
        [name in Metric]?: string;
    };
    metricOptions: {
        [name in Metric]?: string[];
    };
    metricPlaceholders: {
        [name in Metric]?: string;
    };
    logos: BrandliftLogo[];
    isCustomFormulations?: boolean;
    version?: number;
    strategy?: BrandliftStrategy;
}

export interface CreateSegmentContext {
    lookalikeValue: 1 | 2 | 3 | 4 | 5;
    questionIndex?: number;
    questionAnswer?: number;
    login?: string;
}

export interface QuicksurveyContext {
    email?: string;
    segment?: CreateSegmentContext;
    version?: number;
}

export interface ChangeFieldPayload {
    field: string | string[];
    value: any;
}
